const isLoading = state => state.loading

export default {
  isLoading
}



// WEBPACK FOOTER //
// ./src/store/modules/loader/getters.js